module.exports = __webpack_public_path__ + "public/img/qrcode-loading.49cf1179.png";